// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3ZWxR","rootCenter":"LoadMoreObserver_rootCenter__3K_AY","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1sQnA"};